import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Axios from "../comp/Utils/axios";
import SummaryAPI from "../comp/Commson/summaryApi";
import { AxiosToastError } from "../comp/Utils/AxiosToastError";
import fetchUserDetails from "../comp/Utils/fetchUserDetail";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../comp/Store/Userslice";
import "../Component/Home/theme.css"; // Import the CSS file

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Login component for user authentication
 *
 * Handles user login and redirects to dashboard if successful
 *
 * @returns {JSX.Element} Login form component
 */
/*******  10819093-9e29-4bf4-a8cd-5973b1662b21  *******/
const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch()

  const [data, setData] = useState({
    email: "",
    password: "",
  });

  // handle input change
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // validation function
  const validate = () => {
    if (!/\S+@\S+\.\S+/.test(data.email)) {
      toast.error("Please enter a valid email");
      return false;
    }
    if (data.password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return false;
    }
    return true;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await Axios.post(
        SummaryAPI.login.url,
        {
          email: data.email,
          password: data.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        toast.success("Login successful 🎉");
        localStorage.setItem("accessToken",response.data.data.accessToken)
        localStorage.setItem("refreshToken",response.data.data.refreshToken) // Fixed: was setting accessToken twice

        const userDetail = await fetchUserDetails()
        dispatch(setUserDetails(userDetail.data))

        setData({
          email: "",
          password: "",
        });
        navigate("/");
      } else {
        toast.error(response?.data?.message || "Login failed");
      }
    } catch (error) {
      AxiosToastError(error);
    }
  };

  return (
    <div 
      className="flex items-center justify-center min-h-screen p-6"
      style={{
        background: "var(--gradient-primary)",
      }}
    >
      <div 
        className="w-full max-w-md rounded-2xl shadow-lg p-8"
        style={{
          backgroundColor: "var(--color-white)",
          boxShadow: "var(--shadow-large)",
        }}
      >
        <h2 className="text-2xl font-bold text-center bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
          Login
        </h2>
        <p className="text-center text-sm mt-2 inter-secondary" style={{ color: "var(--color-primary-500)" }}>
          Welcome back to Laminance Cabinetry 🚀
        </p>

        <form onSubmit={handleLogin} className="mt-6 space-y-4">
          {/* Email */}
          <div>
            <label className="block text-sm font-medium inter-secondary" style={{ color: "var(--color-primary-500)" }}>
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none transition-all duration-300 inter-secondary"
              style={{
                borderColor: "var(--border-medium)",
                color: "var(--color-gray-600)",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "var(--color-primary-500)";
                e.target.style.boxShadow = "0 0 0 2px var(--color-primary-100)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "var(--border-medium)";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          {/* Password */}
          <div className="relative">
            <label className="block text-sm font-medium inter-secondary" style={{ color: "var(--color-primary-500)" }}>
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={data.password}
              onChange={handleChange}
              required
              placeholder="Enter password"
              className="w-full mt-1 px-4 py-2 border rounded-lg focus:outline-none transition-all duration-300 inter-secondary"
              style={{
                borderColor: "var(--border-medium)",
                color: "var(--color-gray-600)",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "var(--color-primary-500)";
                e.target.style.boxShadow = "0 0 0 2px var(--color-primary-100)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "var(--border-medium)";
                e.target.style.boxShadow = "none";
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-9"
              style={{ color: "var(--color-gray-500)" }}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>

          {/* Forgot Password */}
          {/* <div className="text-right">
            <span
              onClick={() => navigate("/forgot-password")}
              className="text-sm cursor-pointer hover:underline inter-secondary"
              style={{ color: "var(--color-primary-500)" }}
            >
              Forgot Password?
            </span>
          </div> */}

          {/* Login Button */}
          <button
            type="submit"
            className="w-full text-white py-2 rounded-lg font-medium transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg inter-secondary"
            style={{
              background: "var(--gradient-primary)",
            }}
          >
            Login
          </button>
        </form>

        {/* Don't have an account */}
       
      </div>
    </div>
  );
};

export default Login;